import Vue from 'vue'
import VueRouter from 'vue-router';
// 页面组件
import EditPage from '../pages/editPage.vue'
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    component: EditPage,
  },
];

const router = new VueRouter({ routes });
export default router